import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/web.url.to-json.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { U8aFixed } from '@polkadot/types-codec';
import { hexToU8a, isHex, isString, isU8a, u8aToU8a } from '@polkadot/util';
import { ethereumEncode, isEthereumAddress } from '@polkadot/util-crypto';
/** @internal */

function decodeAccountId(value) {
  if (isU8a(value) || Array.isArray(value)) {
    return u8aToU8a(value);
  } else if (isHex(value) || isEthereumAddress(value.toString())) {
    return hexToU8a(value.toString());
  } else if (isString(value)) {
    return u8aToU8a(value);
  }

  return value;
}
/**
 * @name GenericEthereumAccountId
 * @description
 * A wrapper around an Ethereum-compatible AccountId. Since we are dealing with
 * underlying addresses (20 bytes in length), we extend from U8aFixed which is
 * just a Uint8Array wrapper with a fixed length.
 */


export var GenericEthereumAccountId = /*#__PURE__*/function (_U8aFixed) {
  _inherits(GenericEthereumAccountId, _U8aFixed);

  var _super = _createSuper(GenericEthereumAccountId);

  function GenericEthereumAccountId(registry) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Uint8Array();

    _classCallCheck(this, GenericEthereumAccountId);

    return _super.call(this, registry, decodeAccountId(value), 160);
  }
  /**
   * @description Compares the value of the input to see if there is a match
   */


  _createClass(GenericEthereumAccountId, [{
    key: "eq",
    value: function eq(other) {
      return _get(_getPrototypeOf(GenericEthereumAccountId.prototype), "eq", this).call(this, decodeAccountId(other));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman() {
      return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      return ethereumEncode(this);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'AccountId';
    }
  }]);

  return GenericEthereumAccountId;
}(U8aFixed);